module.exports = __webpack_public_path__ + "static/img/paytm.87d730d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paytm.png
// module id = 253
// module chunks = 0